import { Dispatch } from 'redux';
import { change } from 'redux-form';
import {
    CHECKOUT_FORM_NAME,
    DEFAULT_SELECTED_FORM_VALUE_FOR_SUBQUESTIONS,
} from '../constants';
import { BUYER_TAX_INVOICE } from '../containers/checkout/constants';
import { getSurvey } from '../selectors/survey';
import { CheckoutState } from '../state';

export const initializeTaxesSurveyQuestions =
    () =>
    (dispatch: Dispatch<CheckoutState>, getState: () => CheckoutState) => {
        const state = getState();
        const { hasIsBusinessQuestion } = getSurvey(state);

        if (!hasIsBusinessQuestion) {
            return;
        }

        dispatch(
            change(
                CHECKOUT_FORM_NAME,
                BUYER_TAX_INVOICE,
                DEFAULT_SELECTED_FORM_VALUE_FOR_SUBQUESTIONS,
            ),
        );
    };
